// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Announcement_announcement__oB8Lj","close":"Announcement_close__D8X1L"};